"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var ReactModal = require("react-modal");
require("./Modal.scss");
exports.Modal = function (props) {
    var modalClass = classNames({ "modal-content": true }, props.modalClassName ? props.modalClassName : 'Modal');
    var modalFooter = props.footer ? React.createElement("div", { className: "modal-footer" }, props.footer) : undefined;
    return (React.createElement(ReactModal, { isOpen: props.isOpen, contentLabel: "", className: modalClass, overlayClassName: props.overlayClassName ? props.overlayClassName : 'Overlay' },
        React.createElement("div", { className: "modal-header" },
            React.createElement("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", onClick: props.onClose },
                React.createElement("span", { "aria-hidden": "true" }, "\u00D7")),
            React.createElement("h4", { className: "modal-title", id: "myModalLabel" }, props.header)),
        React.createElement("div", { className: "modal-body container-fluid" }, props.children),
        modalFooter));
};
//# sourceMappingURL=Modal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Modal/Modal.js
// module id = 586
// module chunks = 1